<template>
  <alert-banner v-if="behind" class="device-time-banner" icon="i-lucide-clock" :message="t('general.time_not_valid_banner')" />
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useIntervalFn, useEventListener } from '@vueuse/core';
import { OrderService } from 'app-core';
import AlertBanner from './AlertBanner.vue';

/**
 * The device clock is behind the newest receipt of this register, so no receipt can be issued
 * (OrderValidation refuses it with "time not valid"). Shown before any receipt is tried, and
 * re-checked every minute and on returning to the app: it goes once the clock is set right.
 */
const { t } = useI18n()
const behind = ref(false)

async function check() {
  behind.value = await OrderService.isDeviceTimeBehind()
}

onMounted(check)
useIntervalFn(check, 60_000)
useEventListener(document, 'visibilitychange', () => {
  if (document.visibilityState === 'visible') check()
})
</script>
